export default "__VITE_ASSET__BtGjpBfi__"